import type { ContainerTypeInput } from '@chukua/common';
import { Alert, Button, Drawer, Form, Input, Switch } from 'antd';
import { useEffect } from 'react';
import type { CatalogueDrawerProps } from '../../../components/CataloguePanel';
import type { ContainerType } from '../../../reference-data.api';

export function ContainerTypeFormDrawer({ open, editing, error, submitting, onSubmit, onClose }: CatalogueDrawerProps<ContainerType, ContainerTypeInput>) {
  const [form] = Form.useForm<ContainerTypeInput>();

  useEffect(() => {
    if (open) form.setFieldsValue(editing ?? { code: '', name: '', needsReeferPower: false, needsSkeletalOrFlatRack: false });
  }, [open, editing, form]);

  async function submit(values: ContainerTypeInput) {
    if (await onSubmit(values)) onClose();
  }

  return (
    <Drawer open={open} onClose={onClose} title={editing ? 'Edit container type' : 'New container type'} placement="right" size={420} destroyOnClose>
      {error && <Alert className="mb-5" type="error" title={error} showIcon />}
      <Form<ContainerTypeInput> form={form} layout="vertical" requiredMark={false} onFinish={submit} disabled={submitting}>
        <Form.Item name="code" label="Code" rules={[{ required: true, message: 'Enter a code' }]}>
          <Input className="font-mono" autoFocus />
        </Form.Item>
        <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Enter a name' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="needsReeferPower" label="Needs reefer power" valuePropName="checked" extra="The truck needs a genset or the trailer must be a reefer.">
          <Switch />
        </Form.Item>
        <Form.Item
          name="needsSkeletalOrFlatRack"
          label="Needs skeletal or flat rack"
          valuePropName="checked"
          extra="The trailer must be skeletal or a flat rack."
        >
          <Switch />
        </Form.Item>
        <Form.Item className="mb-0 pt-2">
          <Button type="primary" htmlType="submit" loading={submitting}>
            {editing ? 'Save' : 'Create container type'}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}
